import { conditions } from "@/data/conditions";
import { articles } from "@/data/articles";
import { serviceDetails } from "@/data/serviceDetails";

// Central bilingual route table. Greek is default (no prefix); English is /en/*.
export const PAGES = [
  { key: "home", el: "/", en: "/en" },
  { key: "homeClassic", el: "/classic", en: "/en/classic" },
  { key: "about", el: "/biografiko", en: "/en/about" },
  { key: "serviceDetail", el: "/ypiresies/:slug", en: "/en/services/:slug" },
  { key: "conditionDetail", el: "/pathiseis/:slug", en: "/en/conditions/:slug" },
  { key: "publications", el: "/dimosiefseis", en: "/en/publications" },
  { key: "practice", el: "/iatreio", en: "/en/practice" },
  { key: "articles", el: "/arthra", en: "/en/articles" },
  { key: "faq", el: "/syxnes-erotiseis", en: "/en/faq" },
  { key: "book", el: "/klisi-rantevou", en: "/en/book" },
  { key: "contact", el: "/epikoinonia", en: "/en/contact" },
  { key: "cancellation", el: "/politiki-akyroseon", en: "/en/cancellation-policy" },
  { key: "payment", el: "/politiki-pliromon", en: "/en/payment-policy" },
  { key: "privacy", el: "/politiki-aporritou", en: "/en/privacy-policy" },
  { key: "terms", el: "/oroi-xrisis", en: "/en/terms-of-use" },
  { key: "cookies", el: "/politiki-cookies", en: "/en/cookie-policy" },
];

function patternToRegex(pattern) {
  const src = "^" + pattern.replace(/:[^/]+/g, "([^/]+)") + "/?$";
  return new RegExp(src);
}

export function matchPath(pathname) {
  const clean = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  for (const page of PAGES) {
    for (const lang of ["en", "el"]) {
      const re = patternToRegex(page[lang]);
      const m = clean.match(re);
      if (m) {
        const params = {};
        const keys = (page[lang].match(/:([^/]+)/g) || []).map((k) => k.slice(1));
        keys.forEach((k, i) => (params[k] = m[i + 1]));
        return { page, lang, params };
      }
    }
  }
  return null;
}

export function buildPath(key, lang = "el", params = {}) {
  const page = PAGES.find((p) => p.key === key);
  if (!page) return lang === "en" ? "/en" : "/";
  let path = page[lang];
  Object.entries(params).forEach(([k, v]) => {
    path = path.replace(":" + k, v);
  });
  return path;
}

// Translate a dynamic slug (condition / article) between languages.
function translateSlug(key, slug, targetLang) {
  const source =
    key === "conditionDetail" ? conditions : key === "articleDetail" ? articles : key === "serviceDetail" ? serviceDetails : [];
  const found = source.find((x) => x.slug.el === slug || x.slug.en === slug);
  return found ? found.slug[targetLang] : slug;
}

// Given the current pathname, return the equivalent path in the target language.
export function alternatePath(pathname, targetLang) {
  const match = matchPath(pathname);
  if (!match) return targetLang === "en" ? "/en" : "/";
  const { page, params } = match;
  const newParams = { ...params };
  if (params.slug) newParams.slug = translateSlug(page.key, params.slug, targetLang);
  return buildPath(page.key, targetLang, newParams);
}
